import { useState, useEffect } from 'react'

import CustomCheckBox from 'components/form/CustomCheckBox'
import Input from 'components/form/Input'
import { RadioGroup } from 'components/form/RadioGroup'
import { RadioItem } from 'components/form/RadioGroup'
import LabeledSelect from 'components/selects/LabeledSelect'
import ProductSearch from './ProductSearch'
import {
  FrequencyOption,
  DurationOption,
  IngestionInstructionOption,
  TimeOfIngestionOption,
} from './constants'
import {useSelector} from "react-redux";

const PrescriptionForm = ({ modalData, setFormData }) => {
  const {
    processing,
    error,
  } = useSelector((state) => state.prescription)

  const [product, setSelectedProduct] = useState(undefined)

  useEffect(() => {
    setSelectedProduct(undefined)
  }, [])

  useEffect(() => {
    if(!processing){
      setSelectedProduct(undefined)
    }
  },[processing])

  return (
    <div>
      <div className="flex">
        <div className="flex flex-1">
          <ProductSearch
            label="Item Name"
            onChange={(data) => {
              setSelectedProduct(data)
              setFormData(
                {
                  item: data.product_id,
                  label: data?.label,
                  weight: data?.weight
                },
                modalData,
              )
            }}
            value={product}
          />
        </div>
      </div>
      <div className="flex">
        <div className="flex flex-1">
          <Input
            type="number"
            placeholder="Frequency"
            onChange={(e) => {
              setFormData({ frequency: e.target.value }, modalData)
            }}
            value={modalData?.frequency ?? ''}
          />
          <div className="w-5" />
          <LabeledSelect
            getOptionLabel={(option) => option.label}
            className="mt-7"
            placeholder="Frequency"
            onChange={(frequency) => {
              setFormData({ frequency_unit: frequency.value }, modalData)
            }}
            options={FrequencyOption}
            value={FrequencyOption.find(
              (freq) => freq.value === modalData?.frequency_unit,
            )}
          />
        </div>
        <div className="w-10" />
        <div className="flex flex-1">
          <Input
            type="number"
            placeholder="Duration"
            onChange={(e) => {
              setFormData({ duration: e.target.value }, modalData)
            }}
            value={modalData?.duration}
          />
          <div className="w-5" />
          <LabeledSelect
            className="mt-7"
            getOptionLabel={(option) => option.label}
            placeholder="Duration"
            options={DurationOption}
            onChange={(duration) => {
              setFormData({ duration_unit: duration.value }, modalData)
            }}
            value={DurationOption.find(
              (dur) => dur.value === modalData?.duration_unit,
            )}
          />
        </div>
      </div>
      <Input
        type="number"
        placeholder="Quantity"
        onChange={(e) => {
          setFormData({ quantity: e.target.value }, modalData)
        }}
        value={modalData?.quantity}
      />
      <div className="flex">
        <RadioGroup label="Instruction">
          {IngestionInstructionOption.map((instruction) => {
            return (
              <RadioItem
                key={instruction.value}
                value={instruction.value}
                isChecked={modalData?.direction?.intake === instruction.value}
                name="Instruction"
                label={instruction.label}
                onChanged={() => {
                  setFormData(
                    {
                      direction: {
                        ...modalData?.direction,
                        intake: instruction.value,
                      },
                    },
                    modalData,
                  )
                }}
              />
            )
          })}
        </RadioGroup>
        <RadioGroup label="Time of ingestion">
          {TimeOfIngestionOption.map((time) => {
            return (
              <CustomCheckBox
                checked={modalData?.direction?.[time.value]}
                key={time.value}
                name="Instruction"
                label={time.label}
                onChange={() => {
                  setFormData(
                    {
                      direction: {
                        ...modalData?.direction,
                        [time.value]: !modalData?.direction?.[time.value],
                      },
                    },
                    modalData,
                  )
                }}
              />
            )
          })}
        </RadioGroup>
      </div>
      <Input
        type="text"
        placeholder="Advice"
        onChange={(e) => {
          setFormData({ advice: e.target.value }, modalData)
        }}
        value={modalData?.advice ?? ''}
      />
    </div>
  )
}

export default PrescriptionForm
